import { Outlet, RouteObject } from "react-router-dom";
import RouteProtector from "./RouteProtector";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import DomesticBranches from "src/business/DomesticBranches";
import LinkRedirect from "./LinkRedirect";
import XbrlErrorMessages from "src/business/ui/xbrlErrorMessages";

const BusinessManageApplication = lazyWithReload(
  () => import("src/business/BusinessManageApplication"),
);

const ActiveApplications = lazyWithReload(
  () => import("src/applications/shared/features/list/activeApplication"),
);

const Files = lazyWithReload(() => import("src/business/Files"));

const XbrlFiles = lazyWithReload(() => import("src/business/XbrlFiles"));
const ChangeCompanyInfo = lazyWithReload(
  () => import("src/business/ChangeCompanyInfo"),
);

const ChangeInfo = lazyWithReload(() => import("src/business/ChangeInfo"));

const DashboardPage = lazyWithReload(
  () => import("src/business/DashboardPage"),
);

const ListApplicationCategories = lazyWithReload(
  () =>
    import("../applications/shared/features/list/listApplicationCategories"),
);

const PastApplications = lazyWithReload(
  () => import("../applications/shared/features/list/pastApplications"),
);

const ChangeNotificationSettings = lazyWithReload(
  () => import("../firebase/features/ChangeNotificationSettings"),
);

export const businessPaths: RouteObject = {
  path: "/business",
  element: <Outlet />,
  children: [
    {
      path: "changeInfo",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ChangeInfo />
        </RouteProtector>
      ),
    },
    {
      path: "changeCompanyInfo",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ChangeCompanyInfo />
        </RouteProtector>
      ),
    },
    {
      path: "dashboard",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <DashboardPage />
        </RouteProtector>
      ),
    },
    {
      path: "newApplicationForm",
      element: (
        <RouteProtector allowedUsers={["isChamber", "isBusiness"]}>
          <ListApplicationCategories branchesOnlyMode={false} />
        </RouteProtector>
      ),
    },
    {
      path: "newApplicationFormForBranches",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ListApplicationCategories branchesOnlyMode={true} />
        </RouteProtector>
      ),
    },
    {
      path: "activeApplications",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isChamber"]}>
          <ActiveApplications />
        </RouteProtector>
      ),
    },
    {
      path: "pastApplications",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <PastApplications />
        </RouteProtector>
      ),
    },
    {
      path: "files",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isChamber"]}>
          <Files />
        </RouteProtector>
      ),
    },
    {
      path: "xbrlFiles",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <XbrlFiles />
        </RouteProtector>
      ),
    },
    {
      path: "xbrlMessages/:guid",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <XbrlErrorMessages />
        </RouteProtector>
      ),
    },
    {
      path: "manageApplication/:id",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <BusinessManageApplication />
        </RouteProtector>
      ),
    },
    {
      path: "manageApplication/",
      element: (
        <LinkRedirect
          fallbackUrl={"/business/activeApplications"}
          param={"appId"}
          urlTo={"/business/manageApplication"}
        />
      ),
    },
    {
      path: "changeNotificationSettings",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <ChangeNotificationSettings />
        </RouteProtector>
      ),
    },
    {
      path: "domesticBranches",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <DomesticBranches />
        </RouteProtector>
      ),
    },
  ],
};
